/**
 * Rename "Products" to "Shop" and reveal nav
 */
document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('nav[aria-label="Primary"]');
  if (!nav) return;

  // Hide nav while script runs
  nav.classList.add('js-nav-hidden');

  // Function to rename text
  const renameLinks = () => {
    const links = nav.querySelectorAll('a');
    links.forEach(link => {
      if (link.textContent.trim() === 'Products') {
        link.textContent = 'Shop';
      }
    });
  };

  // Handle themes that load nav asynchronously
  const observer = new MutationObserver(() => {
    renameLinks();
    nav.classList.remove('js-nav-hidden');
    nav.classList.add('js-nav-ready');
    observer.disconnect();
  });

  // Watch for menu changes
  observer.observe(nav, { childList: true, subtree: true });

  // Run immediately in case nav is already rendered
  renameLinks();
  nav.classList.remove('js-nav-hidden');
  nav.classList.add('js-nav-ready');
});
